import React from "react";

import FurtherReadingByline from "./further-reading-byline";

class FurtherReadingListChapterItem extends React.Component {
  publisherAndYear() {
    if (this.props.item.data.Publisher && this.props.item.data.Year) {
      return (
        <>
          ({this.props.item.data.Publisher}, {this.props.item.data.Year})
        </>
      );
    } else if (this.props.item.data.Publisher) {
      return (
        <>({this.props.item.data.Publisher})</>
      );
    } else if (this.props.item.data.Year) {
      return (
        <>({this.props.item.data.Year})</>
      );
    }

    return null;
  }

  render() {
    return (
      <li className="further-reading__list-item">
        <div className="further-reading__details">
          <div className="further-reading__title">
            {this.props.item.data.Title}
          </div>
          <FurtherReadingByline author={this.props.item.data.Author} />

          {(this.props.item.data.Description) ? (
            <p>
              {this.props.item.data.Description}
            </p>
          ) : null}

          <div className="further-reading__containing-volume">
            in{' '}
            <i>{this.props.item.data.Collection}</i>{' '}
            {this.publisherAndYear()}
            {(this.props.item.data.Pages) ? 
            `, ${this.props.item.data.Pages}` : null}
          </div>
        </div>
      </li>
    );
  }
}

export default FurtherReadingListChapterItem;